import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import typeQuestions from '@/utils/format-edit/myprofileTypeQuestions.json'
import {
  DEFAULT_MYPROFILE_TYPES,
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileTypesCard',
  props: {
    currentCardId: null,
    formatId: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
};



const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const myboom = computed({
  get: () => String(formatData.myboom ?? ''),
  set: (value: string) => {
    formatData.myboom = value
  }
})

const holiday = computed({
  get: () => String(formatData.holiday ?? ''),
  set: (value: string) => {
    formatData.holiday = value
  }
})

const wanted = computed({
  get: () => String(formatData.wanted ?? ''),
  set: (value: string) => {
    formatData.wanted = value
  }
})

function typeValue(idx: number) {
  return stringListItem(formatData.types, idx)
}

function setType(idx: number, val: string) {
  setStringListItem(
    formatData,
    'types',
    idx,
    val,
    DEFAULT_MYPROFILE_TYPES.length,
    DEFAULT_MYPROFILE_TYPES
  )
}

return { __sfc: true,props, formatData, isSection, myboom, holiday, wanted, typeValue, setType, typeQuestions }
}

})